var map = {
	"./frontend/AndroidGuide.vue": 33727,
	"./frontend/Banking.vue": 38194,
	"./frontend/BetslipHistory.vue": 2648,
	"./frontend/BodyFB.vue": 91644,
	"./frontend/Commission.vue": 55389,
	"./frontend/ContactUs.vue": 94493,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 40277,
	"./frontend/History.vue": 97139,
	"./frontend/Home.vue": 17683,
	"./frontend/IOSGuide.vue": 74873,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 56549,
	"./frontend/Index.vue": 99864,
	"./frontend/Live.vue": 31445,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 90826,
	"./frontend/MatchResult.vue": 10188,
	"./frontend/MaungFB.vue": 87551,
	"./frontend/Promotion.vue": 88592,
	"./frontend/Setting.vue": 29126,
	"./frontend/VideoLink.vue": 49026,
	"./frontend/VipLevels.vue": 53007,
	"./frontend/Withdraw.vue": 6707,
	"./frontend/auth/Login.vue": 56781,
	"./frontend/auth/Register.vue": 38532,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 76485,
	"./frontend/auth/VerifyNotAuth.vue": 30295,
	"./frontend/components/AccountSelect.vue": 5056,
	"./frontend/components/AppHeader.vue": 15953,
	"./frontend/components/DataTable.vue": 93536,
	"./frontend/components/FBPreviewVoucher.vue": 73448,
	"./frontend/components/FBVoucher.vue": 19686,
	"./frontend/components/FootballTeamCard.vue": 88101,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/HomeBanner.vue": 71987,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 26955,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 27051,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 55881,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 96172,
	"./frontend/normal-user/2d/2d.vue": 2899,
	"./frontend/normal-user/2d/ClosedDays.vue": 42835,
	"./frontend/normal-user/2d/Home.vue": 39097,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 75634,
	"./frontend/normal-user/3d/Home.vue": 3079,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 41950,
	"./frontend/normal-user/game/Arcade.vue": 69403,
	"./frontend/normal-user/game/Fishing.vue": 37174,
	"./frontend/normal-user/game/Game.vue": 91217,
	"./frontend/normal-user/game/Slot.vue": 97397,
	"./frontend/normal-user/shankomee/Room.vue": 41296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;